export const triggerRewardsNotification = () => {
    const event = new Event('pointsGained', {'bubbles': true});
    document.dispatchEvent(event);
};